import { PERMISSIONS } from '../constants/permissions';
import type { WfhModuleCapabilities } from '../types/wfh';
import { hasPermission } from '../utils/permissions';

/**
 * WFH capabilities from mounted backend routes (arkhrmsapi wfh.routes.js).
 *
 * Mounted:
 * - GET /wfh/dashboard, /wfh/history, /wfh/:id, /wfh/:id/attendance-log
 * - POST /wfh
 * - POST /wfh/:id/cancel|approve|reject
 */
export const WFH_ROUTE_CAPABILITIES = {
  dashboard: true,
  history: true,
  details: true,
  attendanceLog: true,
  apply: true,
  cancel: true,
  policies: false,
  adminRequests: true,
  wfhApproval: true,
  approveAction: true,
  rejectAction: true,
} as const;

export function getWfhModuleCapabilities(
  permissions: readonly string[],
): WfhModuleCapabilities {
  const canRead = hasPermission(permissions, PERMISSIONS.WFH_APPLY);
  const canApprove = hasPermission(permissions, PERMISSIONS.WFH_APPROVE);
  return {
    canViewHistory: canRead && WFH_ROUTE_CAPABILITIES.history,
    canViewDetails: (canRead || canApprove) && WFH_ROUTE_CAPABILITIES.details,
    canApply: canRead && WFH_ROUTE_CAPABILITIES.apply,
    canCancel: (canRead || canApprove) && WFH_ROUTE_CAPABILITIES.cancel,
    hasPolicyLookup: canRead && WFH_ROUTE_CAPABILITIES.policies,
    canViewAdminRequests: canApprove && WFH_ROUTE_CAPABILITIES.adminRequests,
    canAccessWfhApproval: canApprove && WFH_ROUTE_CAPABILITIES.wfhApproval,
  };
}
